export default {
	namespaced: true,
	state: {
		1044:{
			"model": [{
				"index": 1,
				"name": "管道x轴",
				"loadName": "pipes/new1.glb",
				"color": "#625F6D",
				"type": 5,
				"scale": {
					"x": 5.5,
					"y": 1,
					"z": 1
				},
				"translate": {
					"x": 0,
					"y": 300,
					"z": 300
				},
				"rotate": {
					"x": 0,
					"y": 0,
					"z": 0
				},
				"position": {
					"x": 0,
					"y": -4,
					"z": 900
				}
			},{
				"index": 2,
				"name": "管道y轴",
				"loadName": "pipes/new1.glb",
				"color": "#625F6D",
				"type": 5,
				"scale": {
					"x": 4.5,
					"y": 1,
					"z": 1
				},
				"translate": {
					"x": 0,
					"y": 300,
					"z": 300
				},
				"rotate": {
					"x": 0,
					"y": Math.PI / 2,
					"z": 0
				},
				"position": {
					"x": 900,
					"y": -4,
					"z": 50
				}
			}]
		}

		
	}, //结束定义state

	getters: {

		getJSON: (state, getters) => (id) => {
			return state[id];
		},
	}, //结束定义getters

	mutations: {
		
	}, //结束创建方法
}


// WEBPACK FOOTER //
// ./src/vueX/model/defaultThreeMap.js